const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    width: '100%',
    marginBottom: '40px',
    gap: theme.spacing(3),
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
    },
    // add animation here for gridTemplateColumns
    transition: 'grid-template-columns 0.3s ease-in-out',
  },
  kanbanTaskCard: {
    // Add any specific styles for the KanbanTaskCard here if needed
  },
  noCourses: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '80px 0px',
    gap: '16px',
    [theme.breakpoints.down('md')]: {
      padding: '40px 16px',
    },
  },
  noCoursesContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
  },
  noCoursesText: {
    fontSize: '18px',
    fontWeight: '500',
    textAlign: 'center',
  },
  blueText: {
    color: '#015ffb',
  },
  noCoursesDescriptionText: {
    fontSize: '14px',
    fontWeight: '400',
    textAlign: 'center',
    color: '#919EAB',
  },
})
export default styles
